import { Claim__ResolutionKind } from '@admin/schema';

import { ClaimSelection } from './types';

export const compensated = (selection: ClaimSelection) =>
  selection.resolution?.kind === Claim__ResolutionKind.Compensated;

export const denied = (selection: ClaimSelection) => selection.resolution?.kind === Claim__ResolutionKind.Denied;
